angular.module('hcap-analytics')
.controller('RootCtrl', [
  '$scope',
  'UserService',
  '$state',
function (
  $scope,
  UserService,
  $state,
) {
  $scope.data = {
    showNavbar: false,
  };

  $scope.$watch(() => {
    const src = !localStorage.getItem('src');
    const params = $state.params || {};
    const bundleAccess = params.bundleToken && params.cohortId;
    const bundleLayout = $state.current.name === 'csm-bundle' || bundleAccess;

    return [src, $state.$current && $state.$current.self.authenticate, bundleLayout, params.portal, UserService.isSignedIn()];
  }, newVal => {
    $scope.data.showNavbar = newVal[0] && (newVal[1] || newVal[2] && newVal[4]);
    $scope.portal = $state.params.portal || 'v2';
  }, true);
}]);
